module.exports = __webpack_public_path__ + "img/ee.c0efdb96.svg";